// extracted by mini-css-extract-plugin
export default {"total":"total___uyy8i","dotted":"dotted___mP9iU"};